export default "__VITE_ASSET__CB7mHLmv__"